(function () {
  'use strict';

  var grid = document.getElementById('shopGrid');
  if (!grid) return;

  var cards = [].slice.call(grid.querySelectorAll('.shop-card'));
  var inputs = [].slice.call(document.querySelectorAll('.shop-filter-input'));
  var chips = [].slice.call(document.querySelectorAll('.shop-scene-chip'));
  var sortSel = document.getElementById('shopSort');
  var countEl = document.getElementById('shopCount');
  var emptyEl = document.getElementById('shopEmpty');
  var filterCountEls = [].slice.call(document.querySelectorAll('#filterCount, #drawerFilterCount, #fabCount'));
  var clearBtns = [].slice.call(document.querySelectorAll('#clearFilters, #clearDrawerFilters'));
  var drawer = document.getElementById('shopDrawer');
  var openDrawer = document.getElementById('openDrawer');
  var closeDrawer = document.getElementById('closeDrawer');
  var overlay = document.getElementById('shopDrawerOverlay');
  var applyDrawer = document.getElementById('applyDrawerFilters');
  var drawerTrigger = null;

  var GROUPS = ['form', 'brightness', 'price', 'battery', 'scene'];
  var PRICE_RANGES = {};
  var DRAWER_FOCUS_SELECTOR = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var LEGACY_FILTER_TO_FORM = {
    'dual-head': 'dual-head',
    folding: 'folding',
    zoomable: 'zoomable'
  };

  function buildPriceRanges() {
    inputs.filter(function (i) { return i.dataset.group === 'price'; }).forEach(function (i) {
      PRICE_RANGES[i.dataset.value] = { min: parseFloat(i.dataset.min), max: parseFloat(i.dataset.max) };
    });
  }
  buildPriceRanges();

  function getCardFilters(card) {
    try { return JSON.parse(card.dataset.filters || '{}'); } catch (e) { return {}; }
  }

  function getActiveFilters() {
    var map = {};
    GROUPS.forEach(function (g) { map[g] = new Set(); });
    inputs.forEach(function (input) {
      if (input.checked) map[input.dataset.group].add(input.dataset.value);
    });
    return map;
  }

  function setActiveFilters(map) {
    inputs.forEach(function (input) {
      var values = map[input.dataset.group] || new Set();
      input.checked = values.has(input.dataset.value);
    });
  }

  function matchesGroup(cardFilters, group, selectedValues) {
    if (!selectedValues.size) return true;
    if (group === 'price') {
      var price = parseFloat(cardFilters.price) || 0;
      for (var i = 0; i < selectedValues.size; i++) {
        var val = Array.from(selectedValues)[i];
        var r = PRICE_RANGES[val];
        if (r && price >= r.min && price < r.max) return true;
      }
      return false;
    }
    if (group === 'brightness') {
      var bright = parseInt(cardFilters.brightness, 10) || 0;
      return Array.from(selectedValues).some(function (v) { return String(bright) === v; });
    }
    var cardVals = cardFilters[group] || [];
    return Array.from(selectedValues).some(function (v) { return cardVals.indexOf(v) !== -1; });
  }

  function sortCards(mode) {
    var sorted = cards.slice().sort(function (a, b) {
      if (mode === 'price-asc') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
      if (mode === 'price-desc') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
      if (mode === 'brightness-desc') return parseInt(b.dataset.brightness, 10) - parseInt(a.dataset.brightness, 10);
      return parseInt(a.dataset.order, 10) - parseInt(b.dataset.order, 10);
    });
    sorted.forEach(function (card) { grid.appendChild(card); });
  }

  function applyFilters() {
    var map = getActiveFilters();
    var sortMode = sortSel ? sortSel.value : 'recommended';
    sortCards(sortMode);

    var visible = 0;
    cards.forEach(function (card) {
      var filters = getCardFilters(card);
      var match = GROUPS.every(function (g) { return matchesGroup(filters, g, map[g]); });
      card.classList.toggle('is-hidden', !match);
      if (match) visible++;
    });

    if (countEl) countEl.textContent = String(visible);
    if (emptyEl) emptyEl.hidden = visible !== 0;

    var totalSelected = GROUPS.reduce(function (sum, g) { return sum + map[g].size; }, 0);
    filterCountEls.forEach(function (el) { el.textContent = String(totalSelected); });

    chips.forEach(function (chip) {
      var active = map.scene.has(chip.dataset.scene);
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    updateURL(map, sortMode);
  }

  function updateURL(map, sortMode) {
    var params = new URLSearchParams();
    GROUPS.forEach(function (g) {
      var vals = Array.from(map[g]);
      if (vals.length) params.set(g, vals.join(','));
    });
    if (sortMode && sortMode !== 'recommended') params.set('sort', sortMode);
    var qs = params.toString();
    var url = window.location.pathname + (qs ? '?' + qs : '');
    window.history.replaceState({}, '', url);
  }

  function readFiltersFromURL() {
    var params = new URLSearchParams(window.location.search);
    var map = {};
    GROUPS.forEach(function (g) {
      var raw = params.get(g);
      map[g] = raw ? new Set(raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean)) : new Set();
    });
    if (!params.has('form')) {
      var legacyFilter = (params.get('filter') || '').trim().toLowerCase();
      if (LEGACY_FILTER_TO_FORM[legacyFilter]) map.form.add(LEGACY_FILTER_TO_FORM[legacyFilter]);
    }
    setActiveFilters(map);
    if (sortSel) {
      var sort = params.get('sort');
      if (sort && [].slice.call(sortSel.options).some(function (o) { return o.value === sort; })) {
        sortSel.value = sort;
      }
    }
    applyFilters();
  }

  function syncAndApply(target) {
    var group = target.dataset.group;
    var value = target.dataset.value;
    var checked = target.checked;
    inputs.forEach(function (input) {
      if (input.dataset.group === group && input.dataset.value === value) input.checked = checked;
    });
    applyFilters();
  }

  inputs.forEach(function (input) {
    input.addEventListener('change', function () { syncAndApply(input); });
  });

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var scene = chip.dataset.scene;
      var currently = getActiveFilters().scene.has(scene);
      inputs.forEach(function (input) {
        if (input.dataset.group === 'scene' && input.dataset.value === scene) input.checked = !currently;
      });
      applyFilters();
    });
  });

  if (sortSel) {
    sortSel.addEventListener('change', function () { applyFilters(); });
  }

  clearBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      inputs.forEach(function (input) { input.checked = false; });
      if (sortSel) sortSel.value = 'recommended';
      applyFilters();
    });
  });

  function isDrawerOpen() {
    return drawer && drawer.classList.contains('is-open');
  }

  function getDrawerFocusTargets() {
    if (!drawer || typeof drawer.querySelectorAll !== 'function') return [];
    return [].slice.call(drawer.querySelectorAll(DRAWER_FOCUS_SELECTOR)).filter(function (el) {
      return typeof el.focus === 'function';
    });
  }

  function getFirstDrawerFocusTarget() {
    var targets = getDrawerFocusTargets();
    if (targets.indexOf(closeDrawer) !== -1) return closeDrawer;
    return targets[0] || null;
  }

  function trapDrawerTab(event) {
    if (event.key !== 'Tab' || !isDrawerOpen()) return;
    var targets = getDrawerFocusTargets();
    if (!targets.length) return;
    var first = targets[0];
    var last = targets[targets.length - 1];
    var current = document.activeElement;
    if (event.shiftKey && (current === first || targets.indexOf(current) === -1)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (current === last || targets.indexOf(current) === -1)) {
      event.preventDefault();
      first.focus();
    }
  }

  function openDrawerFn(trigger) {
    if (!drawer) return;
    if (trigger && typeof trigger.focus === 'function') drawerTrigger = trigger;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusTarget = getFirstDrawerFocusTarget();
    if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
  }
  function closeDrawerFn() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (drawerTrigger && typeof drawerTrigger.focus === 'function') drawerTrigger.focus();
  }
  if (openDrawer) openDrawer.addEventListener('click', function () { openDrawerFn(openDrawer); });
  if (closeDrawer) closeDrawer.addEventListener('click', closeDrawerFn);
  if (overlay) overlay.addEventListener('click', closeDrawerFn);
  if (applyDrawer) applyDrawer.addEventListener('click', closeDrawerFn);
  document.addEventListener('keydown', function (event) {
    trapDrawerTab(event);
    if (event.key === 'Escape' && isDrawerOpen()) {
      event.preventDefault();
      closeDrawerFn();
    }
  });

  readFiltersFromURL();
})();
